import { MenuCountersResponseSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';
import { adminKeys } from '../admin-keys';

export const useMenuCounters = () =>
  useQuery({
    queryKey: adminKeys.menuCounters(),
    queryFn: async ({ signal }) => {
      const raw = await apiFetch<unknown>('/menu/counters', { signal });
      return MenuCountersResponseSchema.parse(raw);
    },
    staleTime: 30_000,
  });
